export enum USER_TYPE_ENUM {
  USER = 'user',
  TEAM = 'team',
}
